// extracted by mini-css-extract-plugin
export default {"cls1":"lmqR01w_hWMKOFxoxmoc","cls2":"U0Qy3MbCHUIUDTkvFYyc lmqR01w_hWMKOFxoxmoc"};